import Vue from "vue";
import Vuex from "vuex";
import ikp from "./ikp.module";
import customer from "./cutomer.nodule";
import auth from "@/modules/auth/auth.store.js";
import allergies from "./allergies.module";
import symptoms from "./symptoms.module";
import drugs from "./drugs.module";
import reciepts from "./reciepts.module";
import documents from "./documents.module";
import appointment from "./appointment.module";
import diseases from "./diseases.module";
import previousAppeal from "./previous-appeal.module";
import parameters from "./parameters.module";
import lightBox from "@/modules/light-box/light-box.store";
import { NotificationStoreModule } from "@/plugins/notifications/notification";
import createPersistedState from "vuex-persistedstate";

const ikpState = createPersistedState({
  paths: ["ikp.closedBlocks"],
});

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    drawer: null,
    hideDrawer: false,
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage: "",
    pageTitle: "",
    socketStatus: "",
  },

  mutations: {
    setSocketStatus(state, payload) {
      state.socketStatus = payload;
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },

    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },

    HIDE_DRAWER(state) {
      state.hideDrawer = true;
      state.drawer = false;
    },

    SET_PAGE_TITLE(state, payload) {
      state.pageTitle = payload;
    },
  },

  actions: {},

  modules: {
    auth,
    customer,
    ikp,
    allergies,
    symptoms,
    drugs,
    reciepts,
    documents,
    diseases,
    previousAppeal,
    parameters,
    appointment,
    [lightBox.name]: lightBox,

    // plugins
    [NotificationStoreModule.name]: NotificationStoreModule,
  },
  plugins: [ikpState],
});

export default store;
